import { Component } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import { Link } from 'react-router';
import { setActionButton, clearActionButton, buildActionButtonProperty } from 'common/actions/actionButtonActions';
import styles from './User.scss';
import icons from 'styles/icons/icons.scss';
import UserDetails from 'part11/components/User/Details/Details';
import UserGroupList from 'part11/components/User/UserGroupList/UserGroupList';
import UserDocumentTypes from 'part11/components/User/UserDocumentTypes/UserDocumentTypes';
import UserBulkActionList from 'part11/components/User/UserBulkActionList/UserBulkActionList';
import RegistrationTasks from 'part11/components/User/RegistrationTasks/RegistrationTasks';
import { userSelector } from 'part11/selectors/sdfa';
import { studyFeatureAccess } from 'common/features/predicates';
import { Conditional } from 'common/components/layout';
import {
    loadUsers,
    clearUsersScene,
    removeUserFromBinder,
    undoRemoveUserFromBinder,
} from 'part11/actions/users';

const Header = ({ user, editPath }) => {
    if (user) {
        return (
            <header className={styles.header} data-cy="User">
                <div className={styles.icon}>
                    <span className={icons.materialIcons}>perm_identity</span>
                </div>
                <span className={styles.title} data-cy="User-fullname">
                    {`${user.firstName} ${user.lastName}`}
                </span>
                <Link className={styles.editLink} to={editPath} data-cy="User-Link">Edit User</Link>
            </header>
        );
    }
};

export class User extends Component {

    constructor(props) {
        super(props);

        const { userId } = props;

        this.editPath = `/admin/users/${userId}/edit`;
        this.createPath = '/admin/users/create';
        this.actionButtonProperty = buildActionButtonProperty('Create User', this.createPath);
    }

    loadData() {
        const { userId, institutionId } = this.props;
        this.props.loadUsers(institutionId, userId);
    }

    componentDidMount() {
        this.loadData();
        this.props.setActionButton(this.actionButtonProperty);
    }

    componentWillUnmount() {
        this.props.clearActionButton();
        this.props.clearUsersScene();
    }

    getUser() {
        const { users, userId } = this.props;
        return users.filter(u => u.id === userId)[0] || {};
    }

    // TODO Remove this once the registration flow has been reworked such that SSO users do not have a set password step
    filterSetPasswordForSsoUsers(registrationSteps) {
        if (registrationSteps.length > 0) {
            lodash.remove(registrationSteps[0].steps, (value) => {
                return value.state.name == 'setting_password';
            });
        }
        return registrationSteps;
    }

    render() {
        const { user, institutionId, userId, hasStudyFeatureAccess,
            removeUserFromBinder, undoRemoveUserFromBinder } = this.props;
        const groups = user && user.groups ? user.groups : [];
        const documentTypes = user && user.documentTypes ? user.documentTypes : [];
        const registrationSteps = user && user.registrationSteps ? user.registrationSteps : [];
        if (user && user.isSso) {
            this.filterSetPasswordForSsoUsers(registrationSteps);
        }
        return (
            <div className={styles.userContainer} data-cy="User-render">
                <Header user={user} editPath={this.editPath} />
                <div className={styles.userInfo} data-cy="User-userInfo">
                    <UserDetails user={user} />
                    <UserGroupList
                        groups={groups}
                        institutionId={institutionId}
                        user={user} />

                    <UserDocumentTypes documentTypes={documentTypes} />
                    <UserBulkActionList
                        tableName={'Binders'}
                        userId={userId}
                        institutionId={institutionId}
                        user={user}
                        removeUserFromBinder={removeUserFromBinder}
                        undoRemoveUserFromBinder={undoRemoveUserFromBinder}
                    />
                    <Conditional condition={hasStudyFeatureAccess}>
                        <UserBulkActionList
                            tableName={'Studies'}
                            userId={userId}
                            institutionId={institutionId}
                            user={user} />
                    </Conditional>
                    <RegistrationTasks tasks={registrationSteps} />
                </div>
            </div>
        );
    }
}

export default connect((state, props) => {
    const userId = props.params.userId;
    const user = userSelector(state, userId);
    const hasStudyFeatureAccess = studyFeatureAccess(state);
    return {
        institutionId: props.params.id || state.me.institution.id,
        userId,
        user,
        hasStudyFeatureAccess,
    };
}, {
    loadUsers,
    clearUsersScene,
    setActionButton,
    clearActionButton,
    removeUserFromBinder,
    undoRemoveUserFromBinder,
})(User);
